import { TransactionKind } from '../models/transaction';

// `color` is a `var(--df-tx-*)` reference, not a literal — light values live in
// _variables.scss, dark values in _theme-dark.scss (Task 14, UI#166). The one consumer binds
// it via `[style.color]` (a native DOM style), which resolves it without `resolveColor()`.
export const TRANSACTION_KIND_STYLES: Record<
	TransactionKind,
	{ color: string; label: string } | null
> = {
	EXTERNAL: { color: 'var(--df-tx-external)', label: 'External' },
	INTERNAL_JOURNAL: { color: 'var(--df-tx-internal-journal)', label: 'Internal Journal' },
	DIVIDEND: { color: 'var(--df-tx-dividend)', label: 'Dividend' },
	INTEREST: { color: 'var(--df-tx-interest)', label: 'Interest' },
	FEE: { color: 'var(--df-tx-fee)', label: 'Fee' },
	CORPORATE_ACTION: { color: 'var(--df-tx-corporate-action)', label: 'Corporate Action' },
	SWEEP: { color: 'var(--df-tx-sweep)', label: 'Sweep' },
	TAX: { color: 'var(--df-tx-tax)', label: 'Tax' },
	UNKNOWN: { color: 'var(--df-tx-unknown)', label: 'Unknown' }
};

/**
 * Kinds surfaced in the read-only "Needs Review" queue. UNKNOWN is the one unclassified
 * kind the backend puts in NEITHER return group (Common/src/Constants/TransactionKindGroups.cs
 * is the authority on which kinds are excluded from or counted in return), so an UNKNOWN
 * row is a movement a human must classify.
 * SWEEP is also in neither group, but it is classified and deliberately neutral
 * (same-account cash<->MMF moves) — it does not need review.
 */
export const NEEDS_REVIEW_KINDS: TransactionKind[] = ['UNKNOWN'];
